import React from 'react';
import { firestore } from '../../contexts/FirebaseContext';

function useAgregarFondos() {
  const verifyReporteFolio = async (folioValue) => {
    const result = (await firestore.collection('payment_reports').where('folio', '==', folioValue).get()).docs.map(
      (doc) => ({ ...doc.data() })
    );

    if (result.length > 0) {
      return false;
    }
    return true;
  };

  return { verifyReporteFolio };
}

export default useAgregarFondos;
